const APP_NAME = "Workleap";

export function formatDocumentTitle(...segments: (string | undefined)[]): string {
    const present = [APP_NAME, ...segments.filter((segment): segment is string => !!segment)];

    return present.filter((segment, index) => segment !== present[index - 1]).join(" - ");
}
